export enum WalletAccessType {
  KeyStore,
  PrivateKey
}
